import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';
import { GridCol } from '@naf/grid';

export const CardGridWrapper = styled(GridCol)`
  margin-bottom: 30px;

  @media (max-width: ${breakpoints.m}) {
    margin-bottom: 0;
  }
`;
